import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import getCurrentPage from 'shared/utils/getCurrentPage'

interface useGetCurrentPageProps {
    setCurrentPage: Function
}

const useGetCurrentPage = (props: useGetCurrentPageProps) => {

    const location = useLocation()

    useEffect(() => {
        getCurrentPage(location).then((curPage) => {
            props.setCurrentPage(curPage)
            
        })
    }, ['', location.pathname])
}

export default useGetCurrentPage